import { NavLink } from "react-router-dom";
import { FiHome, FiBook, FiUser, FiLogOut } from "react-icons/fi";

export default function StudentSidebar({ onLogout }) {
  return (
    <aside className="hidden md:flex flex-col w-64 bg-card border-r border-border min-h-screen p-4 shadow-sm">
      <div className="mb-8">
        <div className="font-bold text-xl text-primary mb-2">🎓 Học viên</div>
      </div>
      <nav className="flex flex-col gap-1">
        <NavLink
          to="/student/dashboard"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded hover:bg-primary/10 transition ${
              isActive ? "bg-primary/10 text-primary font-semibold" : "text-text2"
            }`
          }
        >
          <FiHome /> Trang chủ
        </NavLink>
        <NavLink
          to="/student/lessons"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded hover:bg-primary/10 transition ${
              isActive ? "bg-primary/10 text-primary font-semibold" : "text-text2"
            }`
          }
        >
          <FiBook /> Bài học
        </NavLink>
        <NavLink
          to="/student/profile"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded hover:bg-primary/10 transition ${
              isActive ? "bg-primary/10 text-primary font-semibold" : "text-text2"
            }`
          }
        >
          <FiUser /> Hồ sơ cá nhân
        </NavLink>
        {/* Thêm các menu khác cho học viên ở đây nếu cần */}
      </nav>
      <div className="mt-auto">
        <button
          onClick={onLogout}
          className="flex items-center gap-2 w-full text-left px-3 py-2 mt-6 rounded hover:bg-error/10 text-error"
        >
          <FiLogOut /> Đăng xuất
        </button>
      </div>
    </aside>
  );
}
